import axios from 'axios';
import _ from 'lodash';
import config from '../utils/config';

const getUserCred = async (email, iss) => {
  let response = await axios.request({
    url: `${config.serverBasePath}/api/v2/keycloak_auth?email=${email}&iss=${iss}`,
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json',
      withCredentials: true,
      'Access-Control-Allow-Origin': '*'
    },
  }).catch((error) => {
    return { data: _.get(error, ['response', 'access_token'], { detail: 'Invalid Credentials' }) };
  });
  response = await response.data;
  if (_.get(response, 'access_token', false)) {
    let photo = await axios.request({
      url: `${config.serverBasePath}/api/v2/users/getPhoto`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${response.access_token}`,
        withCredentials: true,
        'Access-Control-Allow-Origin': '*'
      },
    });
    photo = await photo.data;
    await window.localStorage.setItem('access_token', response.access_token);
    await window.localStorage.setItem('photo', photo);
  } else {
    return { detail: response.detail };
  }
  return response.access_token;
};

export default getUserCred;
